import cn from 'classnames';
import { useRouter } from 'next/router';
import { memo } from 'react';
import { TOTAL_PAGINATION } from '@zmedia/bm-soccer-ui/constants';
import { UrlUtils } from '@zmedia/bm-soccer-ui/utils';
import { Element, IconButton, RouterLink } from '@zmedia/bm-soccer-ui/components';
import styles from './styles.module.scss';

interface IProps {
    startPage: number;
    currentPage: number;
    isFetching: boolean;
    hasMore: boolean;
    showButtonLoadMore?: boolean;
    loaderRef: any;
}

const parseUrl = (path: string) => {
    if (typeof path !== 'string') return '';

    const removeQuery = path.split('?')[0];
    if (removeQuery === '/') return '';

    const pathArr = removeQuery?.replace('.epi', '').split('/trang');
    return pathArr[0];
};

const LoadMore = ({
    isFetching,
    currentPage,
    hasMore,
    showButtonLoadMore = true,
    startPage,
    loaderRef,
}: IProps) => {
    const router = useRouter();

    const showPrevBtn = Number(router.query?.page) > 1;
    const showButtons = currentPage >= startPage + TOTAL_PAGINATION && hasMore;
    const pathname = parseUrl(router.asPath);
    const nextUrl =
        `${pathname}/trang${startPage + TOTAL_PAGINATION + 1}.epi` +
        UrlUtils.getQueryString(router.asPath);

    const prevUrl =
        `${pathname}/trang${startPage - 2}.epi` + UrlUtils.getQueryString(router.asPath);

    return (
        <>
            {showButtonLoadMore && !isFetching && (
                <Element className={styles['load-more']}>
                    {showPrevBtn && (
                        <RouterLink to={prevUrl}>
                            <IconButton
                                className={styles['is-prev']}
                                outlined={true}
                                text="Quay lại"
                            />
                        </RouterLink>
                    )}
                    {showButtons && (
                        <RouterLink to={nextUrl}>
                            <IconButton
                                text="Xem thêm"
                                className={cn(
                                    styles['is-next'],
                                    styles['is-primary']
                                )}
                            />
                        </RouterLink>
                    )}
                </Element>
            )}
            {hasMore && !isFetching && !showButtons && (
                <div
                    ref={loaderRef}
                    style={{ marginTop: '100px', height: '1px' }}
                ></div>
            )}
        </>
    );
};

export default memo(LoadMore);
